<script>
	import {Disclose} from 'agnostic-svelte'
	export let name;
	export let value;
</script>

<Disclose isBackground title={`${name}: ${value}`}>
	<slot></slot>
</Disclose>